import getTranslationsByLocale from '../../utils/getTranslations';
import { GET_TRANSLATIONS } from '../types';

const initialState = {
  common: {},
  locationsDetails: {
    locations: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSLATIONS:
      return {
        ...state,
        ...getTranslationsByLocale(action.payload),
      };
    default:
      return state;
  }
};
